import React from 'react';
import { Modal } from '@keplerco/core';
import { useBlocker } from 'react-router';
import { ConfirmationModalLayout } from '../../widgets/layouts';

function handleBeforeUnload(event: BeforeUnloadEvent) {
  event.preventDefault();
  return 'You have unsaved changes. Are you sure you want to exit? Any unsaved changes will be lost.';
}

export function ExitModal({ hasUnsavedChanges }: { hasUnsavedChanges: boolean }): React.ReactElement {
  React.useEffect(() => {
    hasUnsavedChanges ? window.addEventListener('beforeunload', handleBeforeUnload) : window.removeEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  const blocker = useBlocker(hasUnsavedChanges);

  function discardChanges() {
    blocker.proceed?.();
  }

  function continueEditing() {
    blocker.reset?.();
  }

  return (
    <Modal open={blocker.state !== 'unblocked'} onClose={continueEditing}>
      <ConfirmationModalLayout title="You have unsaved changes" subtitle="Are you sure you want to exit? Any unsaved changes will be lost." cancelButtonText="Discard changes" onClickCancel={discardChanges} submitButtonText="Continue editing" onClickSubmit={continueEditing} />
    </Modal>
  );
}
